import { FunctionComponent } from 'react';
import Highlighter from 'react-highlight-words';

import { LeadApplicant } from '@kanda-libs/ks-frontend-services';

import { HIGHLIGHT_PROPS } from 'components/lead/LeadTable/LeadName/constants';
import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';

export interface LeadNameProps {
  customerDetails: LeadApplicant['customer_details'];
}

const LeadName: FunctionComponent<LeadNameProps> = function ({
  customerDetails,
}) {
  const [query] = useQuery('companies');
  const searchWords = useSearchWords(query);

  const name = [customerDetails?.first_name, customerDetails?.last_name]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="flex flex-col text-16-20 text-neutral-900">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={name || ''}
        className="text-16-20-em"
      />
    </div>
  );
};

export default LeadName;
